import React from "react";
import { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Description as DocumentationIcon } from "@mui/icons-material";
import {ReactComponent as APILandingPageIcon} from "../../images/APITestingNewIconLandingPage.svg"

const APITestingLandingPage = () => {

  const [testDesignAutomation, setTestDesignAutomation] = useState("");
  const [testAutomationOnly, setTestAutomationOnly] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();
      navigate("/dashboard/api-testing/flow-selection", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleConfirm = (type) => () => {
    if (type === "testDesignAutomation") {

      navigate("/dashboard/api-testing/manual")
    }
    else if (type === "testAutomationOnly") {
      navigate("/dashboard/api-testing/uploadapi")
    }
  }


  return (
    <Box
      sx={{
        width: "100%",
        height: "95vh",
        backgroundColor: "#B3D6FF40",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 10,
        padding: { xs: 2, md: 8 },
        boxSizing: "border-box",
        color: "#fff"
      }}
    >
      {/* Left SVG Illustration */}
      {/* <Box
        sx={{
          maxWidth: 500,
          width: "100%"
        }}
      >
        <APILandingPageIcon width="100%" height="auto" />
      </Box> */}

      {/* Right Content */}
      <Box sx={{ maxWidth: 500, width: "100%" }}>
        <Typography variant="h4" sx={{ fontWeight: 600, color: "#4ea6f4", mb: 1,  }}>
          API Testing
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 4 , color: "black"}}>
          Automated Testing. Assured Quality
        </Typography>

        {/* Button 1 */}
        <Button
          variant="contained"
          disableRipple
          fullWidth
          onClick={handleConfirm("testDesignAutomation")}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            textAlign: "left",
           backgroundColor: "#ffff",
            boxShadow: "none",
            padding: 2,
            mb: 3,
            gap: 2,
            textTransform: "none",
            border: "2px solid #b7d6f6ff", // light border
            borderRadius: 2,
            transition: "background-color 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.2)", // light transparent hover effect
              boxShadow: "none",
              border: "1px solid rgba(255, 255, 255, 0.3)" // slightly bolder on hover
            }
          }}
        >
          <DocumentationIcon style={{ minWidth: "32px", color: "#4ea6f4" }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#4ea6f4" }}>
              API Test Design
            </Typography>
            <Typography variant="body2" sx={{ color: "black" , mb: 1 }}>
              Upload or import API specifications (OpenAPI/Postman/Swagger), auto-generate test scenarios,
              design test cases, and generate RTM.
            </Typography>
          </Box>
        </Button>

        {/* Button 2 */}
        <Button
          variant="contained"
          disableRipple
          fullWidth
          onClick={handleConfirm("testAutomationOnly")}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            textAlign: "left",
          backgroundColor: "#ffffff",
            boxShadow: "none",
            padding: 2,
            mb: 3,
            gap: 2,
            textTransform: "none",
            border: "2px solid #b7d6f6ff", // light border
            borderRadius: 2,
            transition: "background-color 0.3s ease",
            "&:hover": {
              backgroundColor: " rgba(25, 118, 210, 0.2)", // light transparent hover effect
              boxShadow: "none",
              border: "1px solid rgba(255, 255, 255, 0.3)" // slightly bolder on hover
            }
          }}
        >
          <DocumentationIcon style={{ minWidth: "32px", color: "#4ea6f4" }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#4ea6f4" }}>
              API Test Automation
            </Typography>
            <Typography variant="body2" sx={{ color: "black", mb: 1 }}>
              Directly automate existing or user-defined API test cases without going through test design or
              scenario generation steps.
            </Typography>
          </Box>
        </Button>
      </Box>
      <Box
        sx={{
          maxWidth: 500,
          width: "100%",
          
        }}
      >
        {/* <APILandingPageIcon width="100%" height="auto" /> */}
        <APILandingPageIcon width="100%" height="auto"  />
      </Box> 
    </Box>
  );
};

export default APITestingLandingPage;
